import React, { useState } from 'react';
import { useQuery, keepPreviousData } from '@tanstack/react-query';
import api, { getCreatorTokens, getWalletTokens } from '../services/api';
import BacktestSection from './BacktestSection';
import EntityConfigEditor from './EntityConfigEditor';
import CopyBtn from './CopyBtn';

/* Popup : tokens d'un créateur ou wallet (peak, time-to-peak, scorecard, filtres, liens Solscan/GMGN). */

const CSS = `
.tdp-ovl{position:fixed;inset:0;background:rgba(0,0,0,.66);backdrop-filter:blur(2px);z-index:200;display:flex;align-items:center;justify-content:center;padding:16px;font-family:'JetBrains Mono',ui-monospace,monospace;color:var(--text,#e6e8ec);}
.tdp-modal{width:92vw;max-width:1100px;height:88vh;background:var(--bg,#0a0b0e);border:1px solid var(--border,#1f2329);border-radius:14px;display:flex;flex-direction:column;overflow:hidden;box-shadow:0 24px 70px rgba(0,0,0,.6);}
.tdp-top{display:flex;align-items:center;gap:12px;padding:12px 16px;border-bottom:1px solid var(--border,#1f2329);background:#0c0d11;flex:0 0 auto;flex-wrap:wrap;}
.tdp-back{background:transparent;border:1px solid var(--border,#1f2329);color:var(--text,#e6e8ec);font-family:inherit;font-size:13px;padding:6px 12px;border-radius:8px;cursor:pointer;}
.tdp-back:hover{background:var(--surface,#14161c);}
.tdp-title{font-size:13px;font-weight:700;}
.tdp-sub{font-size:11px;color:var(--text2,#8a8f98);}
.tdp-sp{flex:1;}
.tdp-lnk{font-size:10px;font-weight:700;letter-spacing:.03em;text-decoration:none;padding:5px 9px;border-radius:6px;border:1px solid var(--border,#1f2329);color:var(--text2,#8a8f98);}
.tdp-lnk:hover{color:var(--text,#e6e8ec);background:var(--surface,#14161c);}
.tdp-lnk.sol{color:#9bd1ff;border-color:rgba(155,209,255,.3);}
.tdp-lnk.gm{color:var(--amber,#ffb020);border-color:rgba(255,176,32,.3);}
.tdp-body{flex:1;overflow:auto;padding:14px 16px;}
.tdp-score{display:grid;grid-template-columns:repeat(6,1fr);gap:8px;margin-bottom:14px;}
@media(max-width:680px){.tdp-score{grid-template-columns:repeat(3,1fr);}.tdp-modal{width:100vw;height:100vh;border-radius:0;}.tdp-ovl{padding:0;}}
.tdp-kpi{background:var(--surface,#14161c);border:1px solid var(--border,#1f2329);border-radius:9px;padding:9px 10px;}
.tdp-kpi .k{font-size:9px;color:var(--text2,#8a8f98);letter-spacing:.06em;text-transform:uppercase;}
.tdp-kpi .v{font-size:16px;font-weight:800;margin-top:3px;}
.tdp-ctrl{display:flex;align-items:center;gap:6px;flex-wrap:wrap;margin-bottom:8px;}
.tdp-ctrl .lbl{font-size:9px;letter-spacing:.08em;text-transform:uppercase;color:var(--text2,#8a8f98);font-weight:600;margin-right:2px;}
.tdp-btn{background:none;border:1px solid var(--border,#1f2329);color:var(--text2,#8a8f98);font-family:inherit;font-size:10px;font-weight:600;padding:5px 10px;border-radius:6px;cursor:pointer;letter-spacing:.03em;}
.tdp-btn.on{background:var(--surface2,#191c23);color:var(--cyan,#22d3ee);border-color:var(--cyan,#22d3ee);}
.tdp-tbl{width:100%;border-collapse:collapse;background:var(--surface,#14161c);border:1px solid var(--border,#1f2329);border-radius:10px;overflow:hidden;}
.tdp-tbl th{font-size:9px;letter-spacing:.08em;text-transform:uppercase;color:var(--text2,#8a8f98);text-align:left;padding:8px 10px;background:#0e1014;}
.tdp-tbl th.num{text-align:right;}
.tdp-tbl td{padding:8px 10px;font-size:11.5px;border-top:1px solid #16191f;}
.tdp-tbl td.num{text-align:right;font-variant-numeric:tabular-nums;}
.tdp-tbl tr.mig{box-shadow:inset 3px 0 0 var(--cyan,#22d3ee);}
.tdp-mint{font-size:10px;color:var(--text2,#8a8f98);cursor:pointer;}
.tdp-tl{font-size:9px;font-weight:700;text-decoration:none;padding:2px 5px;border-radius:4px;margin-right:4px;}
.tdp-tl.sol{color:#9bd1ff;} .tdp-tl.gm{color:var(--amber,#ffb020);}
.tdp-tl:hover{background:var(--surface2,#191c23);}
.tdp-pos{color:var(--green,#00e08a);} .tdp-neg{color:var(--red,#ff3b5c);} .tdp-muted{color:var(--text2,#8a8f98);}
.tdp-badge{font-size:9px;font-weight:700;padding:2px 6px;border-radius:5px;}
.tdp-badge.rug{background:rgba(255,59,92,.16);color:var(--red,#ff3b5c);}
.tdp-badge.mig{background:rgba(34,211,238,.16);color:var(--cyan,#22d3ee);}
.tdp-badge.alm{background:rgba(255,176,32,.16);color:var(--amber,#ffb020);}
.tdp-empty{padding:30px;text-align:center;color:var(--text2,#8a8f98);font-size:12px;}
.tdp-more{margin-top:12px;text-align:center;}
.tdp-bt-card{border:1px solid var(--border,#1f2329);border-radius:12px;padding:14px;margin-bottom:20px;background:var(--surface2,#191c23);box-shadow:inset 0 0 0 1px rgba(34,211,238,.04);}
.tdp-bt-hd{font-size:11px;font-weight:700;letter-spacing:.04em;color:var(--text,#e6e8ec);margin-bottom:12px;padding-bottom:10px;border-bottom:1px solid var(--border,#1f2329);}
.tdp-search{width:100%;max-width:340px;background:var(--surface,#14161c);border:1px solid var(--border,#1f2329);border-radius:7px;color:var(--text,#e6e8ec);font-family:inherit;font-size:11px;padding:7px 10px;margin-bottom:10px;outline:none;display:block;}
.tdp-search:focus{border-color:var(--cyan,#22d3ee);}
.tdp-bot-section{margin-top:22px;padding-top:16px;border-top:1px solid var(--border,#1f2329);}
.tdp-tl.dx{color:var(--green,#00e08a);}
`;

const SORTS = [{ label: 'Peak', v: 'peak' }, { label: 'Time-to-peak', v: 'time_to_peak' }, { label: 'Récent', v: 'recent' }];
const PEAK_PRESETS = [
  { label: 'Tous', v: null }, { label: '≥+50%', v: 50 }, { label: '≥+100%', v: 100 },
  { label: '≥+300%', v: 300 }, { label: '≥+500%', v: 500 }, { label: '≥+1000%', v: 1000 },
];
const RUG_OPTS = [{ label: 'Tous', v: null }, { label: 'Sans rug', v: 'false' }, { label: 'Que rug', v: 'true' }];
const TTP_BANDS = [
  { label: 'Tous', tpMin: null, tpMax: null },
  { label: '≤2s', tpMin: null, tpMax: 2 },
  { label: '≤10s', tpMin: null, tpMax: 10 },
  { label: '≥30s', tpMin: 30, tpMax: null },
];
const LIFE_BANDS = [
  { label: 'Toutes', v: null }, { label: '≥1min', v: 60 }, { label: '≥10min', v: 600 }, { label: '≥1h', v: 3600 },
];
// time-to-rug = vitesse de mort d'un token rugé (= sa lifetime_sec). Une bande force rugged=true.
const TTR_BANDS = [
  { label: 'Tous', lifeMin: null, lifeMax: null },
  { label: '≤30s', lifeMin: null, lifeMax: 30 },
  { label: '≤2min', lifeMin: null, lifeMax: 120 },
  { label: '≤10min', lifeMin: null, lifeMax: 600 },
  { label: '≥1h (lent)', lifeMin: 3600, lifeMax: null },
];
const PERIOD_BANDS = [
  { label: 'Tout', days: null }, { label: '24h', days: 1 }, { label: '7j', days: 7 }, { label: '30j', days: 30 },
];
const SOURCE_OPTS = [{ label: 'Toutes', v: null }, { label: 'our_position', v: 'our_position' }, { label: 'creator_enum', v: 'creator_enum' }];

const trunc = (s) => (s ? `${s.slice(0, 6)}…${s.slice(-4)}` : '—');
const fmtPeak = (v) => v == null ? <span className="tdp-muted">—</span> : <span className={v >= 0 ? 'tdp-pos' : 'tdp-neg'}>{v >= 0 ? '+' : ''}{v.toFixed(1)}%</span>;
const fmtTtp = (v) => v == null ? <span className="tdp-muted">—</span> : `${v}s`;
const fmtDur = (v) => v < 60 ? `${v}s` : v < 3600 ? `${Math.round(v / 60)}min` : `${(v / 3600).toFixed(1)}h`;
// time-to-rug = lifetime_sec d'un token rugé (sa vitesse de mort) ; N/A si non rugé.
const fmtTtr = (t) => (t.rugged && t.lifetime_sec != null)
  ? <span className="tdp-neg">{fmtDur(t.lifetime_sec)}</span>
  : <span className="tdp-muted">—</span>;
const fmtPct = (v) => v == null ? '—' : `${v}%`;
// Date contextuelle (unix secondes) : creator/regle = création token (first_seen_unix), wallet = entrée (ts_observed).
const fmtUnix = (u) => u ? new Date(u * 1000).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : '—';
const fmtBonding = (t) => {
  const v = t.max_bonding_progress;
  if (v == null) return <span className="tdp-muted">—</span>;
  const almost = !t.migrated && v >= 80;
  const color = t.migrated ? 'var(--cyan,#22d3ee)' : almost ? 'var(--amber,#ffb020)' : 'inherit';
  return <span style={{ color, fontWeight: almost ? 700 : 400 }}>{v}%</span>;
};

const SOLSCAN = (x) => `https://solscan.io/account/${x}`;
const GMGN_ADDR = (x) => `https://gmgn.ai/sol/address/${x}`;
const GMGN_TOKEN = (x) => `https://gmgn.ai/sol/token/${x}`;
const DEXSCREENER = (x) => `https://dexscreener.com/solana/${x}`;

export default function TokenDrillPanel({ kind, id, onClose, openBacktest = false }) {
  const [showBt, setShowBt] = useState(openBacktest);
  const [sort, setSort] = useState('recent');
  const [sortDir, setSortDir] = useState('desc');
  const [minPeak, setMinPeak] = useState(null);
  const [migratedOnly, setMigratedOnly] = useState(false);
  const [rugged, setRugged] = useState(null);
  const [ttp, setTtp] = useState(TTP_BANDS[0]);
  const [tradedOnly, setTradedOnly] = useState(false);
  const [source, setSource] = useState(null);
  const [lifeMin, setLifeMin] = useState(null);
  const [ttr, setTtr] = useState(TTR_BANDS[0]);
  const [period, setPeriod] = useState(PERIOD_BANDS[0]);
  const [limit, setLimit] = useState(100);
  const [search, setSearch] = useState('');
  const [botLimit, setBotLimit] = useState(200);
  const isCreator = kind === 'creator';

  // time-to-rug actif → ne concerne que les rugés : force rugged=true + bande lifetime (override Rug/Survie).
  const ttrActive = ttr.label !== 'Tous';
  const effRugged = ttrActive ? 'true' : rugged;
  const effLifeMin = ttrActive ? ttr.lifeMin : lifeMin;
  const effLifeMax = ttrActive ? ttr.lifeMax : null;

  const createdAfter = period.days == null ? undefined : Math.floor(Date.now() / 1000) - period.days * 86400;
  // clic en-tête : même colonne → inverse le sens ; autre colonne → nouvelle colonne en desc.
  const onSort = (col) => { if (sort === col) { setSortDir((d) => (d === 'asc' ? 'desc' : 'asc')); } else { setSort(col); setSortDir('desc'); } };
  const arrow = (col) => (sort === col ? (sortDir === 'asc' ? ' ▲' : ' ▼') : '');

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['drill', kind, id, sort, sortDir, minPeak, migratedOnly, effRugged, ttp.label, ttr.label, tradedOnly, source, effLifeMin, effLifeMax, period.label, limit],
    queryFn: () => (isCreator ? getCreatorTokens : getWalletTokens)(id, {
      sort, sortDir, minPeak, migratedOnly, rugged: effRugged, tpMin: ttp.tpMin, tpMax: ttp.tpMax,
      lifeMin: effLifeMin, lifeMax: effLifeMax,
      tradedOnly: isCreator ? tradedOnly : false, source: isCreator ? source : undefined,
      createdAfter: isCreator ? createdAfter : undefined,
      limit, skip: 0,
    }),
    placeholderData: keepPreviousData,
  });

  // Trades du bot via cette entité (armed_activation_id = kind:id)
  const { data: botData, isLoading: botLoading } = useQuery({
    queryKey: ['drill-bot', kind, id, botLimit],
    queryFn: () => api.get('/positions/closed', {
      params: { armed_activation_id: `${kind}:${id}`, limit: botLimit, shadow: 'all' },
    }).then(r => r.data),
    staleTime: 30000,
    placeholderData: keepPreviousData,
  });

  // Config armée existante (gate + sortie) pour préremplir l'éditeur ET préserver
  // mode/size au save (PUT entities fait un UPSERT qui écrase les champs absents).
  const { data: entData, refetch: refetchEnt } = useQuery({
    queryKey: ['drill-entity', kind, id],
    queryFn: () => api.get('/arming/entities').then(r => r.data),
    staleTime: 15000,
  });
  const entityRow = (entData?.entities || []).find(
    e => e.kind === kind && e.address === id
  ) || null;
  const entityInitial = {
    __key: `${kind}:${id}`,
    max_pct_above_genesis: entityRow?.max_pct_above_genesis,
    max_progress: entityRow?.max_progress,
    max_token_age_sec: entityRow?.max_token_age_sec,
    crash_brutal_velocity_threshold: entityRow?.crash_brutal_velocity_threshold,
    crash_brutal_grace_sec: entityRow?.crash_brutal_grace_sec,
    tp_take_pct: entityRow?.tp_take_pct,
    trailing_pct: entityRow?.trailing_pct,
  };
  const saveEntityConfig = async (values) => {
    // Endpoint config-only : n'écrit QUE les 7 colonnes gate+sortie, ne touche jamais
    // mode/size → aucun clobber, aucune race read-modify-write (cf. fugu Lot 2).
    await api.put('/arming/entities/config', { kind, address: id, ...values });
    refetchEnt();
  };

  const s = data?.summary || {};
  const tokens = data?.tokens || [];
  const total = data?.total ?? 0;

  // Filtre recherche côté client : substring case-insensitive sur mint et real_mint
  const _q = search.trim().toLowerCase();
  const displayTokens = _q
    ? tokens.filter(t =>
        (t.mint || '').toLowerCase().includes(_q) ||
        (t.real_mint || '').toLowerCase().includes(_q)
      )
    : tokens;

  return (
    <div className="tdp-ovl" onClick={onClose}>
      <style>{CSS}</style>
      <div className="tdp-modal" onClick={(e) => e.stopPropagation()}>
        <div className="tdp-top">
          <div>
            <div className="tdp-title">{isCreator ? 'Créateur' : 'Wallet'} <span className="tdp-mint" title={id} onClick={() => navigator.clipboard?.writeText(id)}>{trunc(id)}</span><CopyBtn text={id} /></div>
            <div className="tdp-sub">{total} token{total > 1 ? 's' : ''}</div>
          </div>
          <div className="tdp-sp" />
          <button className="tdp-lnk" onClick={() => setShowBt(v => !v)} style={{ cursor: 'pointer' }}>⏱ Backtest</button>
          <a className="tdp-lnk sol" href={SOLSCAN(id)} target="_blank" rel="noopener noreferrer">Solscan ↗</a>
          <a className="tdp-lnk gm" href={GMGN_ADDR(id)} target="_blank" rel="noopener noreferrer">GMGN ↗</a>
          <button className="tdp-back" onClick={onClose} style={{ marginLeft: 4 }}>✕</button>
        </div>

        <div className="tdp-body">
          {showBt && <BacktestSection kind={kind} address={id} />}

          <EntityConfigEditor
            initial={entityInitial}
            showAge={kind !== 'wallet'}
            onSave={saveEntityConfig}
            kind={kind}
            address={id}
            label={`Config entrée + sortie (TP/SL) — ${isCreator ? 'créateur' : 'wallet'}${entityRow ? ` · armé: ${entityRow.mode}` : ' · non armé'}`}
          />

          <div className="tdp-score">
            <div className="tdp-kpi"><div className="k">Tokens</div><div className="v">{s.n ?? '—'}</div></div>
            <div className="tdp-kpi"><div className="k">Hit ≥+50%</div><div className="v">{fmtPct(s.hit_50_pct)}</div></div>
            <div className="tdp-kpi"><div className="k">Hit ≥+100%</div><div className="v">{fmtPct(s.hit_100_pct)}</div></div>
            <div className="tdp-kpi"><div className="k">Peak médian</div><div className="v">{s.peak_median_pct == null ? '—' : `+${s.peak_median_pct}%`}</div></div>
            <div className="tdp-kpi"><div className="k">t-peak médian</div><div className="v">{s.ttp_median_sec == null ? '—' : `${s.ttp_median_sec}s`}</div></div>
            <div className="tdp-kpi"><div className="k">% rug · migré</div><div className="v">{fmtPct(s.rug_pct)} · {fmtPct(s.migrated_pct)}</div></div>
          </div>

          <div className="tdp-ctrl">
            <span className="lbl">Tri</span>
            {SORTS.map(o => <button key={o.v} className={`tdp-btn ${sort === o.v ? 'on' : ''}`} onClick={() => onSort(o.v)}>{o.label}{arrow(o.v)}</button>)}
            <span className="lbl" style={{ marginLeft: 8 }}>Peak</span>
            {PEAK_PRESETS.map(o => <button key={o.label} className={`tdp-btn ${minPeak === o.v ? 'on' : ''}`} onClick={() => setMinPeak(o.v)}>{o.label}</button>)}
          </div>
          <div className="tdp-ctrl">
            <span className="lbl">Rug</span>
            {RUG_OPTS.map(o => <button key={o.label} className={`tdp-btn ${rugged === o.v ? 'on' : ''}`} onClick={() => setRugged(o.v)}>{o.label}</button>)}
            <span className="lbl" style={{ marginLeft: 8 }}>t-peak</span>
            {TTP_BANDS.map(o => <button key={o.label} className={`tdp-btn ${ttp.label === o.label ? 'on' : ''}`} onClick={() => setTtp(o)}>{o.label}</button>)}
          </div>
          <div className="tdp-ctrl">
            <span className="lbl">Survie</span>
            {LIFE_BANDS.map(o => <button key={o.label} className={`tdp-btn ${!ttrActive && lifeMin === o.v ? 'on' : ''}`} disabled={ttrActive} onClick={() => setLifeMin(o.v)}>{o.label}</button>)}
            <button className={`tdp-btn ${migratedOnly ? 'on' : ''}`} style={{ marginLeft: 8 }} onClick={() => setMigratedOnly(m => !m)}>migrés seulement</button>
          </div>
          <div className="tdp-ctrl">
            <span className="lbl">Time-to-rug</span>
            {TTR_BANDS.map(o => <button key={o.label} className={`tdp-btn ${ttr.label === o.label ? 'on' : ''}`} onClick={() => setTtr(o)}>{o.label}</button>)}
            {ttrActive && <span className="lbl" style={{ marginLeft: 8, color: 'var(--red,#ff3b5c)' }}>= rugés uniquement</span>}
          </div>
          {isCreator && (
            <div className="tdp-ctrl">
              <button className={`tdp-btn ${tradedOnly ? 'on' : ''}`} onClick={() => setTradedOnly(m => !m)}>tradés par nous</button>
              <span className="lbl" style={{ marginLeft: 8 }}>Source</span>
              {SOURCE_OPTS.map(o => <button key={o.label} className={`tdp-btn ${source === o.v ? 'on' : ''}`} onClick={() => setSource(o.v)}>{o.label}</button>)}
              <span className="lbl" style={{ marginLeft: 8 }}>Période</span>
              {PERIOD_BANDS.map(o => <button key={o.label} className={`tdp-btn ${period.label === o.label ? 'on' : ''}`} onClick={() => setPeriod(o)}>{o.label}</button>)}
            </div>
          )}

          {/* Champ recherche libre (filtre client sur mint / real_mint) */}
          <input
            className="tdp-search"
            type="text"
            placeholder="Rechercher une adresse…"
            value={search}
            onChange={e => setSearch(e.target.value)}
          />

          {isError ? <div className="tdp-empty">Erreur : {error?.message || 'inconnue'}</div>
            : isLoading ? <div className="tdp-empty">Chargement…</div>
            : tokens.length === 0 ? <div className="tdp-empty">Aucun token.</div>
            : displayTokens.length === 0 ? <div className="tdp-empty">Aucun résultat pour « {search.trim()} ».</div>
            : (
              <table className="tdp-tbl">
                <thead><tr>
                  <th>Mint</th>
                  <th className="num" style={{ cursor: 'pointer', userSelect: 'none' }} onClick={() => onSort('recent')}>
                    {kind === 'wallet' ? 'Entrée' : 'Créé'}{arrow('recent')}
                  </th>
                  <th className="num" style={{ cursor: 'pointer', userSelect: 'none' }} onClick={() => onSort('peak')}>
                    Peak%{arrow('peak')}
                  </th>
                  <th className="num" style={{ cursor: 'pointer', userSelect: 'none' }} onClick={() => onSort('time_to_peak')}>
                    t-peak{arrow('time_to_peak')}
                  </th>
                  <th className="num" style={{ cursor: 'pointer', userSelect: 'none' }} onClick={() => onSort('lifetime')}>
                    t-rug{arrow('lifetime')}
                  </th>
                  <th className="num" style={{ cursor: 'pointer', userSelect: 'none' }} onClick={() => onSort('bonding')}>
                    Bonding{arrow('bonding')}
                  </th>
                  {kind === 'wallet' && <th className="num">Achat wallet</th>}
                  <th>Créateur</th>
                  <th>Statut</th><th>Liens</th>
                </tr></thead>
                <tbody>
                  {displayTokens.map(t => (
                    <tr key={t.mint} className={t.migrated ? 'mig' : ''}>
                      <td><span className="tdp-mint" title={t.mint} onClick={() => navigator.clipboard?.writeText(t.mint)}>{trunc(t.mint)}</span><CopyBtn text={t.mint} /></td>
                      <td className="num" style={{ fontSize: 10 }}>{fmtUnix(kind === 'wallet' ? t.ts_observed : t.first_seen_unix)}</td>
                      <td className="num">{fmtPeak(t.peak_gain_vs_launch_pct)}</td>
                      <td className="num">{fmtTtp(t.time_to_peak_sec)}</td>
                      <td className="num">{fmtTtr(t)}</td>
                      <td className="num">{fmtBonding(t)}</td>
                      {kind === 'wallet' && <td className="num">{t.wallet_buy_price != null ? t.wallet_buy_price.toExponential(2) : '—'}</td>}
                      {(() => {
                        const cr = t.creator_address || (isCreator ? id : null);
                        return (
                          <td>
                            {cr ? (
                              <>
                                <span className="tdp-mint" title={cr} onClick={() => navigator.clipboard?.writeText(cr)}>{trunc(cr)}</span><CopyBtn text={cr} />{' '}
                                <a className="tdp-tl gm" href={GMGN_ADDR(cr)} target="_blank" rel="noopener noreferrer">GM</a>
                              </>
                            ) : <span className="tdp-muted">—</span>}
                          </td>
                        );
                      })()}
                      <td>
                        {t.rugged && <span className="tdp-badge rug">rug</span>}{' '}
                        {t.migrated && <span className="tdp-badge mig">migré</span>}
                        {!t.migrated && t.max_bonding_progress != null && t.max_bonding_progress >= 80 && <span className="tdp-badge alm">almost</span>}
                        {kind === 'creator' && t.traded && <span className="tdp-badge mig">tradé</span>}
                      </td>
                      <td>
                        {/* SS = vue compte (marche sur mint réel ET bc_pda). GM/DEX = page token
                            (mint réel requis) → masqués quand seul le bc_pda est connu (t.real_mint null). */}
                        <a className="tdp-tl sol" href={SOLSCAN(t.mint)} target="_blank" rel="noopener noreferrer">SS</a>
                        {t.real_mint && <a className="tdp-tl gm" href={GMGN_TOKEN(t.real_mint)} target="_blank" rel="noopener noreferrer">GM</a>}
                        {t.real_mint && <a className="tdp-tl dx" href={DEXSCREENER(t.real_mint)} target="_blank" rel="noopener noreferrer">DEX</a>}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}

          {tokens.length >= limit && (
            <div className="tdp-more"><button className="tdp-btn" onClick={() => setLimit(l => l + 100)}>charger plus</button></div>
          )}

          {/* Section : trades effectués par le bot via cette entité armée */}
          {(() => {
            const botPositions = botData?.positions || [];
            const botCount = botPositions.length;
            const botTotal = botData?.total ?? botCount;
            const fmtDate = (s) => s
              ? new Date(s).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })
              : '—';
            return (
              <div className="tdp-bot-section">
                <div className="tdp-bt-hd">Tradé par le bot ({botLoading ? '…' : (botTotal > botCount ? `${botCount} / ${botTotal}` : botCount)})</div>
                {botLoading
                  ? <div className="tdp-empty">Chargement…</div>
                  : botCount === 0
                    ? <div className="tdp-empty">Aucun trade du bot via cette entité.</div>
                    : (
                      <table className="tdp-tbl">
                        <thead><tr>
                          <th>Token</th>
                          <th className="num">PnL%</th>
                          <th className="num">Peak exit</th>
                          <th className="num" title="Peak du token vs NOTRE prix d'entrée (gain max théorique depuis l'achat)">Peak /entrée</th>
                          <th className="num" title="Prix à la décision d'achat vs launch (mesure 'on entre tard')">Entrée /launch</th>
                          <th className="num">Ouvert</th>
                          <th className="num">Fermé</th>
                          <th>Liens</th>
                        </tr></thead>
                        <tbody>
                          {botPositions.map(p => (
                            <tr key={p.id}>
                              <td>
                                {(() => { const dispMint = p.ui_mint || p.token_address; return (
                                  <><span className="tdp-mint" title={dispMint} onClick={() => navigator.clipboard?.writeText(dispMint)}>{trunc(dispMint)}</span><CopyBtn text={dispMint} /></>
                                ); })()}
                                {p.token_symbol && <span style={{ fontSize: 10, marginLeft: 4, color: 'var(--text2,#8a8f98)' }}>{p.token_symbol}</span>}
                              </td>
                              <td className="num">{fmtPeak(p.pnl_percent)}</td>
                              <td className="num">{fmtPeak(p.exit_peak_pnl)}</td>
                              <td className="num">{fmtPeak(p.peak_pct_entry)}</td>
                              <td className="num">{p.dec_pct_above_genesis == null ? <span className="tdp-muted">—</span> : <span className={p.dec_pct_above_genesis * 100 >= 100 ? 'tdp-neg' : 'tdp-muted'}>{p.dec_pct_above_genesis >= 0 ? '+' : ''}{Math.round(p.dec_pct_above_genesis * 100)}%</span>}</td>
                              <td className="num" style={{ fontSize: 10 }}>{fmtDate(p.opened_at)}</td>
                              <td className="num" style={{ fontSize: 10 }}>{fmtDate(p.closed_at)}</td>
                              <td>
                                <a className="tdp-tl sol" href={SOLSCAN(p.token_address)} target="_blank" rel="noopener noreferrer">SS</a>
                                {p.ui_mint && <a className="tdp-tl gm" href={GMGN_TOKEN(p.ui_mint)} target="_blank" rel="noopener noreferrer">GM</a>}
                                {p.ui_mint && <a className="tdp-tl dx" href={DEXSCREENER(p.ui_mint)} target="_blank" rel="noopener noreferrer">DEX</a>}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )
                }
                {botTotal > botCount && botLimit < 500 && (
                  <div className="tdp-more"><button className="tdp-btn" onClick={() => setBotLimit(l => Math.min(l + 200, 500))}>charger plus ({botCount}/{botTotal})</button></div>
                )}
              </div>
            );
          })()}
        </div>
      </div>
    </div>
  );
}
